export enum AuthActionType {
    LOGIN = "LOGIN",
    REGISTRATION = "REGISTRATION"
}
export enum AuthActionType {
    LOGIN = "LOGIN",
    REGISTRATION = "REGISTRATION"
}
